import { render, staticRenderFns } from "./chatchannel.vue?vue&type=template&id=7013c9c6&"
import script from "./chatchannel.vue?vue&type=script&lang=js&"
export * from "./chatchannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports